import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  ListItemText,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  ListItemButton,
} from "@mui/material";

const drawerWidth = 240;

const LibraryHub = (): React.JSX.Element => {
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex" }}>
      <AppBar
        position="fixed"
        color="secondary"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Component Library
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <List>
          {[
            "Inputs",
            "Navigation",
            "Layout",
            "Surfaces",
            "Feedback",
            "Data Display",
            "Utils",
          ].map((text) => (
            <ListItemButton
              key={text}
              onClick={() => {
                startTransition(() => {
                  navigate(`/library/${text.toLowerCase().replace(" ", "-")}`);
                });
              }}
            >
              <ListItemText primary={text} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      <main style={{ flexGrow: 1, padding: 3, marginTop: "64px" }}>
        <Typography paragraph>
          Select a category from the left to view components.
        </Typography>
      </main>
    </div>
  );
};

export default LibraryHub;
